declare namespace $ {

	type $shm_hitalama_map_widget_page__widget_shm_hitalama_map_widget_float_settings_widget_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_widget_page['controlled_widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_page['widget'] >
	>
	type $mol_text__text_shm_hitalama_map_widget_float_settings_widget_page_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_hitalama_map_widget_float_settings_widget_page extends $shm_hitalama_map_widget_float_settings {
		style_display( ): string
		Page( ): $shm_hitalama_map_widget_page
		Message( ): $mol_text
		style( ): ({ 
			'display': ReturnType< $shm_hitalama_map_widget_float_settings_widget_page['style_display'] >,
		})  & ReturnType< $shm_hitalama_map_widget_float_settings['style'] >
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map